import ClockoutController from '../../core/clockout.controller';
import Inherit from '../../core/inherit';
import ReportsDelegate from './reports.delegate';
import { calculateDateRange } from '../../utils/dates';

class ReportsController extends Inherit(ClockoutController, ReportsDelegate) {
    async initialize() {
        // Check if user has valid data (not just an empty object)
        if (!this.user || !this.user.access || this.user.access.length === 0) {
            this.navigateLogin();
            return;
        }

        this.setState({ user: this.data.user });
        
        // Load both users and transactions data
        await this.loadUsers();
        await this.loadTransactions();
        
        this.setState({ loading: false });
    }

    async loadUsers() {
        try {
            const users = await this.data.fetchUsers();
            this.setState({ 
                users: users?.users || [], 
                usersRows: users?.users || [] 
            });
        } catch (error) {
            console.error('Error loading users:', error);
        }
    }

    async loadTransactions() {
        try {
            const ledger = await this.data.fetchLedger();
            this.setState({ 
                ledger: ledger || {}, 
                transactionsRows: ledger?.transactions || [] 
            });
        } catch (error) {
            console.error('Error loading transactions:', error);
        }
    }

    async applyFilters() {
        const { filters, activeTab } = this.state;
        this.setState({ loading: true });
        
        try {
            if (activeTab === 'users') {
                // Calculate date ranges based on selections
                const { start, end } = calculateDateRange(filters.timeFrame, filters.dateRange);
                const apiFilters = {
                    ...filters,
                    start,
                    end,
                };
                const users = await this.data.fetchUsers(apiFilters);
                this.setState({ users: users?.users, usersRows: users?.users });
            }
            // Transactions filters can be applied client-side or via API if needed
        } catch (error) {
            console.error('Error applying filters:', error);
        } finally {
            this.setState({ loading: false });
        }
    }

    async resetFilters() {
        this.setState({
            loading: true,
            filters: {
                timeFrame: 'all',
                dateRange: null,
                enrollment: 'enrolled',
                hasCompleteDDSwitch: null,
            },
        });
        
        try {
            await this.loadUsers();
        } catch (error) {
            console.error('Error resetting filters:', error);
        } finally {
            this.setState({ loading: false });
        }
    }
}

export default ReportsController;

